import { useState, useEffect } from 'react'
import debounce from 'lodash.debounce'
import ReactSlider from 'react-slider'
import { Input, Label, Grid } from 'semantic-ui-react'

import styles from './style.module.css'

function formatNumberWithCommas(number) {
  if (number === null) return null 

  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function SalaryInputs({ onChange, startValue, endValue }) {
  const [doubleVal, setDoubleVal] = useState([startValue ?? null, endValue ?? null])

  useEffect(() => {
    onChange(doubleVal)
  }, [doubleVal])
  

  const handleStartChange = (event) => {
    const inputValue = event.target.value;
    const val = inputValue.replace(/[^0-9]/g, ''); // Exclude non-numerical characters
    if (val > 0) {
      return setDoubleVal([val, doubleVal[1]])
    } else {
      return setDoubleVal(['', doubleVal[1]])
    }
  }

  const handleEndChange = (event) => {

    const inputValue = event.target.value;
    const val = inputValue.replace(/[^0-9]/g, ''); // Exclude non-numerical characters

    if (val > 0) {
      return setDoubleVal([doubleVal[0], val])
    } else {
      return setDoubleVal([doubleVal[0], ''])
    }
  } 

  return (
    <div className={styles.inputContainer}>
      <Grid style={{ marginTop: "10px" }}>
        <Input labelPosition='right' type='text' placeholder='40,000' onChange={handleStartChange} size="large">
          <Label basic size='large'>$</Label>
          <input value={formatNumberWithCommas(doubleVal[0])} />
          <Label size='large'>.00</Label>
        </Input>
      </Grid>
      <br />
      <Grid style={{ marginTop: "10px", marginBottom: "25px" }}>
        <Input labelPosition='right' type='text' placeholder='90,000' onChange={handleEndChange} size="large">
          <Label basic size='large'>$</Label>
          <input value={formatNumberWithCommas(doubleVal[1])} />
          <Label size='large'>.00</Label>
        </Input>            
      </Grid>         
    </div>
  )
}

export default function SalarySlider({ value, onChange, range, input, startValue, endValue }) {
  const [val, setVal] = useState(value)

  useEffect(() => {
    if (input) return
    if (range) {
      // setDoubleVal(value)
    } else {
      setVal(value)
    }
  }, [value])

  if (input)
    return (
      <SalaryInputs
        // value={value}
        startValue={startValue}
        endValue={endValue}
        onChange={onChange}
        range={range}
        input={input}
      />
    )

  const updateState = debounce(function () {
    if (range) {
      // onChange(doubleVal)
    } else {
      onChange(val)
    }
  }, 200)

  const handleChange = (newVal, idx) => {
    if (range) {
      setDoubleVal(newVal)
    } else {
      setVal(newVal)
    }
  }

  if (range) {
    return (
      <div className={styles.container} style={{ width: '100%' }}>
        <div className={styles.note}>
          Note: this will remove jobs from search that are missing salary data
        </div>
        <div className={styles.number} key={val}>
          ${doubleVal[0]}k - ${doubleVal[1]}k
        </div>
        <ReactSlider
          min={0}
          max={900}
          className={styles.horizontalSliderRange}
          thumbClassName={styles.thumb}
          trackClassName={styles.track}
          value={doubleVal}
          step={10}
          onChange={handleChange}
          onAfterChange={updateState}
          renderThumb={(props, state) => <div {...props}>{state.valueNow}</div>}
        />
      </div>
    )
  }

  return (
    <div className={styles.container}>
      <div className={styles.note}>
        Note: this will remove jobs from search that are missing salary data
      </div>
      <div className={styles.number} key={val}>
        ${val}k+
      </div>
      <ReactSlider
        min={0}
        max={500}
        className={styles.horizontalSlider}
        thumbClassName={styles.thumb}
        trackClassName={styles.track}
        value={val}
        onChange={handleChange}
        onAfterChange={updateState}
        renderThumb={(props, state) => <div {...props}>{state.valueNow}</div>}
      />
    </div>
  )
}
